module.exports = __webpack_public_path__ + "img/Avatar-27.df0e2676.svg";